var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "bubble-tags searchTagsDisplay" },
    [
      _vm._l(_vm.tags, function (data, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "searchFilterTag",
            attrs: { "data-filter": data.filter },
          },
          [_vm._v(_vm._s(data.valueDisplay))]
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }